import React, { createContext, useReducer } from 'react';
import axios from 'axios';

const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return {
                ...state,
                isAuthenticated: true,
                user: action.payload.user,
            };
        case 'LOGOUT':
            // End Laravel Session
            axios.post('/logout').then(response => {
                // Navigate Home
                window.location.href = process.env.REACT_APP_BASE_URL;
            }).catch(error => {
                console.error('Logout error:', error);
            });
            return {
                ...state,
                isAuthenticated: false,
                user: null,
            };
        default:
            return state;
    }
};

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
   
    const [state, dispatch] = useReducer(authReducer, {
        isAuthenticated: false,
        user: null,
    });

    return (
        <AuthContext.Provider value={{state, dispatch}}>
            {children}
        </AuthContext.Provider>
    );

}

export const initiateXSRFToken = () => {
    // replace endpoint with the actual sanctum url
    let sanctum_url = process.env.REACT_APP_API_ENDPOINT.replace('/api', '/sanctum');
    axios.get(sanctum_url + '/csrf-cookie').then(response => {
        console.log(response);
    });
} 

export const checkAuth = () => {
    // Quick return for testing de-coupled
    // return Promise.resolve(false);
    // return Promise.resolve({ authenticated: true, user: { id: 1, name: 'John Doe' } });
    return axios.get('/check-authenticated').then(response => {
        if( response.status === 200 && response.data.authenticated ){
            return response.data;
        }
        return false;
    }).catch(error => {
        console.error('Check Auth error:', error);
        return false;
    });
}